import React, { useEffect } from 'react';
import Overlay from '../overlay/Overlay';
import CenteredFeedbackContainer from './CenteredFeedbackContainer';
import Feedback from './Feedback';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import { hideFeedback } from 'store/reducers/feedback';
import { useNavigate } from 'react-router-dom';

export default function FeedbackOverlay() {
  // feedback state
  const { open, content, type, closeTime, redirectURL } = useSelector((state) => state.feedback);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Auto-close after 3 seconds
  useEffect(() => {
    if (open && (type === 'success' || type === 'error')) {
      const timer = setTimeout(() => {
        dispatch(hideFeedback());
        redirectURL && navigate(redirectURL);
      }, 3000);

      return () => clearTimeout(timer); // Clear timer on unmount or when open changes
    }
  }, [open, dispatch, type]);

  return ReactDOM.createPortal(
    <Overlay sx={{ backdropFilter: 'blur(1px)', alignItems: 'start' }} visible={open}>
      <CenteredFeedbackContainer>
        <Feedback feedback={content} type={type} />
      </CenteredFeedbackContainer>
    </Overlay>,
    document.getElementById('feedback-root')
  );
}
